import React, { useState, useEffect } from 'react';

import {
    ButtonGroup, Tooltip, Zoom, Typography, MenuItem, tooltipClasses, styled, Button, TextField,
    useMediaQuery, Dialog, DialogTitle, DialogContent, DialogActions, Box, Checkbox
} from '@mui/material';

import { useTheme } from '@mui/material/styles';
import { DataGrid } from '@mui/x-data-grid';

import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import CircularProgress from '@mui/material/CircularProgress';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import './Partes.css';
import MostrarError from '../../components/AccionesPartes/MostrarError';
import CargaSpinner from '../../components/AccionesPartes/CargaSpinner';
import TextFieldFecha from '../../components/AccionesPartes/TextFieldFecha';

const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(10),
        border: '1px solid #dadde9',

    },
}));

function PreConforme() {
    const API_URL = 'https://api.workers.grupotel.com/';

    let hoteles = localStorage.getItem('hoteles');
    const [hotelesLista, setHotelesLista] = useState([]);
    const [hotelTrabajo, setHotelTrabajo] = useState(0);

    //Conjunto para mostrar un Alert con el resultado de la petición
    const [mensajeError, setMensajeError] = useState('');
    const [tipoError, setTipoError] = useState('');
    const [contadorError, setContadorError] = useState(1);
    const [contadorSpinner, setContadorSpinner] = React.useState(false);
    const [estadoAlert, setEstadoAlert] = React.useState(false);

    // Lado Izquierdo
    const [actualizo, setActualizo] = useState(true);
    const [estadoInicial, setEstadoInicial] = React.useState(true);

    // Lado Derecho
    const [actualizo2, setActualizo2] = useState(true);

    const [activoFiltro, setActivoFiltro] = useState(false);
    const [estadoFiltros, setEstadoFiltros] = React.useState(false);
    const [datosFiltro, setDatosFiltro] = useState({
        id_factura: '',
        n_factura: '',
        cif: '',
        mostrar: '0',
        fecha_desde: '',
        fecha_hasta: ''
    });
    const [datosFiltroTemp, setDatosFiltroTemp] = useState({});

    const [datos, setDatos] = useState([]);
    const [facturaSeleccionada, setFacturaSeleccionada] = useState([]);
    const [tablaFacturas, setTablaFacturas] = useState("");
    const [tablaPartes, setTablaPartes] = useState(null);
    const [tipoMostrar, setTipoMostrar] = useState([{ value: '0', label: 'Faltan Confirmar' }, { value: '1', label: 'Confirmadas por Usuario' }, { value: '2', label: 'Todas' }]);
    const [idPartes, setIdPartes] = useState(""); // Partes a Buscar

    const [listaPartes, setListaPartes] = useState([]);
    const [disabledPartes, setDisabledPartes] = useState(false);

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const mostrarError = (mensajeError, tipoError) => {
        setMensajeError(mensajeError);
        if (tipoError) {
            setTipoError(tipoError);
        } else {
            setTipoError("error");
        }
        setContadorError(contadorError + 1);
        setEstadoAlert(true);
        const timer2 = setTimeout(() => {
            setEstadoAlert(false);
        }, 3000);
        return () => clearTimeout(timer2);
    };

    const cambiaHotelTrabajo = (event) => {
        if (event.target.name === 'id_hotel') {
            setHotelTrabajo(event.target.value);
        }
    };

    const actualizar = () => {
        setActualizo(!actualizo);
    };
    const actualizar2 = () => {
        setActualizo2(!actualizo2);
    };

    const fd = new FormData();
    const requestOptions = {
        method: 'POST',
        body: fd
    };

    /***********************************************/
    // Filtros
    const ocultarFiltros = () => {
        setEstadoFiltros(false);
        actualizar();
    };

    const ocultarFiltros2 = () => { // Solo oculta los filtros.
        setEstadoFiltros(false);
        setDatosFiltro(datosFiltroTemp);
        comprobarEstadoFiltros();
    };

    const comprobarESC = (event) => {
        if (event.keyCode === 27) {
            ocultarFiltros();
        }
    };

    const comprobarEstadoFiltros = () => { // Comprobamos si hay algun valor en datosFiltro
        const hayFiltrosActivos = Object.values(datosFiltro).some(
            (valor) => valor !== '' && valor !== false && valor !== 0 && valor.length !== 0 && valor != "0"
        );
        setActivoFiltro(hayFiltrosActivos);
    };

    const mostrarFiltros = () => {
        setDatosFiltroTemp({ ...datosFiltro });
        setActivoFiltro(true);
        setEstadoFiltros(true);
    };

    const eliminarFiltros = () => {
        setDatosFiltro({
            id_factura: '',
            n_factura: '',
            cif: '',
            mostrar: '0',
            fecha_desde: '',
            fecha_hasta: ''
        });
    };

    const comprobarEnter = (e) => {
        if (e.key === 'Enter') {
            guardarDatos();
        }
    };

    //Funcion para realizar el Filtro de los partes.
    const guardarDatos = () => {
        const datos = datosFiltro;
        var str = '';

        Object.keys(datos).forEach((nombre, i) => {
            if (Object.values(datos)[i] !== '' && Object.values(datos)[i] !== undefined) {
                if (nombre === "fecha_hasta" || nombre === "fecha_desde") {
                    let fecha_ordenada = "";

                    // Dividir la cadena de la fecha en partes usando el separador "-"
                    const partes = Object.values(datos)[i].split("-");

                    // Reorganizar las partes para que la fecha esté en formato "yyyy-mm-dd"
                    fecha_ordenada = partes[2] + "-" + partes[1] + "-" + partes[0];
                    str += nombre + "=" + fecha_ordenada + '|';
                } else {
                    str += nombre + "=" + Object.values(datos)[i] + '|'
                }
            }
        });
        // console.log(str);
        setEstadoFiltros(false);
        setActivoFiltro(false);
        comprobarEstadoFiltros();
        actualizar();
    };

    const actualizarFiltros = (event) => {
        // console.log(event);
        const { name, value } = event.target;
        if (name === 'id_factura' || name === 'n_factura') {
            const validValue = value.replace(/[^0-9,]/g, ''); // Eliminar cualquier carácter no numérico o coma
            setDatosFiltro({
                ...datosFiltro,
                [name]: validValue,
            });
        } else {
            setDatosFiltro({
                ...datosFiltro,
                [name]: value,
            });
        }
    };
    const actualizarFechaDesde = (fecha) => {
        setDatosFiltro({ ...datosFiltro, fecha_desde: fecha });
    };
    const actualizarFechaHasta = (fecha) => {
        setDatosFiltro({ ...datosFiltro, fecha_hasta: fecha });
    };

    const actualizarPartes = (event) => {
        const validValue = event.target.value.replace(/[^0-9,]/g, '').trim();
        setIdPartes(validValue);
    };

    /***********************************************/
    // Filtros Partes
    const [botonFiltroPartes, setBotonFiltroPartes] = useState(false);
    const [activoFiltroPartes, setActivoFiltroPartes] = useState(false);
    const [estadoFiltroPartes, setEstadoFiltroPartes] = React.useState(false);
    const [datosFiltroPartes, setDatosFiltroPartes] = useState({
        id: '',
        titulo: '',
        operacion: '',
        tipo: '',
        prioridad: '',
        bloque: [],
        planta: [],
        hab: '',
        fecha_desde: '',
        fecha_hasta: '',
        id_asignado: '',
        id_creador: '',
        historico_observacion: ''
    });
    const [datosFiltroPartesTemp, setDatosFiltroPartesTemp] = useState({});

    const parteInicial = [ //parteInicial
        { valor: '', nombre: '', },
        { valor: 'normal', nombre: 'Normal', },
        { valor: 'No conformidad', nombre: 'No conformidad', },
        { valor: 'objeto perdido', nombre: 'Objeto Perdido', },
        { valor: 'amenity', nombre: 'Amenity', } //,
        // { valor: 'bloqueo', nombre: 'Bloqueo', },
    ];
    const [tipoPartes, setTipoPartes] = useState(parteInicial);
    //Listado de los Usuarios con el mismo id Departamento.
    const [usuariosLista, setUsuariosLista] = useState([{ value: '', label: '' }]);
    // Todos los usuarios de un hotel
    const [usuariosHotel, setUsuariosHotel] = useState([{ value: '', label: '' }]);

    //Lista Bloques del hotel en Filtros.
    const [bloquesLista, setBloquesLista] = useState([]);
    const [plantasLista, setPlantasLista] = useState([]);

    const estadosInicial = [
        { valor: '', nombre: '', },
        { valor: 'nuevo', nombre: 'Nuevo', },
        { valor: 'asignado', nombre: 'Asignado', },
        { valor: 'en ejecucion', nombre: 'En ejecución', },
        { valor: 'terceros', nombre: 'Terceros', },
        { valor: 'cerrado', nombre: 'Cerrado', },
        { valor: 'anulado', nombre: 'Anulado', },
    ];
    const [tipoEstados, setTipoEstados] = useState(estadosInicial);

    const prioridadInicial = [
        { valor: 'baja', nombre: 'Baja', },
        { valor: 'media', nombre: 'Media', },
        { valor: 'alta', nombre: 'Alta', },
    ];
    const [tipoPrioridad, setTipoPrioridad] = useState(prioridadInicial);

    const obtenerDatosSelect = () => {
        fd.append("f", "partes.getDatosSelect");
        fd.append("token", localStorage.getItem('token'));

        fetch(API_URL, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.error.id === 0) {
                    // console.log(result);
                    const tipoConDefecto = [{ valor: '', nombre: '' }, ...result.tipo];
                    setTipoPartes(tipoConDefecto);

                    const estadoConDefecto = [{ valor: '', nombre: '' }, ...result.operacion];
                    setTipoEstados(estadoConDefecto);

                    setTipoPrioridad(result.prioridad);
                } else {
                    setTipoPartes(parteInicial);
                    setTipoEstados(estadosInicial);
                    setTipoPrioridad(prioridadInicial);

                    mostrarError(result.error.msg);
                    console.log(result.error.msg)
                }
            })
            .catch(() => {
                mostrarError("No se ha podido actualizar los Tipos de Parte");
                console.log("No se ha podido actualizar los Tipos de Parte");
            })
    };

    const obtenerUsuarios = () => {
        //Contendrá el listado de usuarios temporalmente.
        let usuarios = [];
        //Añadimos el primer valor vacio para el select.
        usuarios.push({ value: '', label: '' });

        fd.append("f", "usuarios.getList");
        fd.append("token", localStorage.getItem('token'));
        //Obtenemos los campos guardados en el localStorage.

        let str = "id_hotel=" + hotelTrabajo + "|id_departamento=" + localStorage.getItem('id_departamento') + '|';
        fd.append("params", str);

        fetch('https://api.workers.grupotel.com/', requestOptions)
            .then(response => response.json())
            .then(result => {
                delete result.error;
                //Recorremos el array de Usuarios para obtener sus id de Usuario y nombres.
                Object.keys(result.usuarios).map((id, i) => {
                    var nombreUsuario = Object.values(result.usuarios)[i].nombre;
                    usuarios.push({ value: id, label: nombreUsuario });
                    return null; // Agregar este return al final de la función de flecha del map. Ya que espera retornar algo.
                })
                //Guardamos el listado de Usuarios para el Select de Editar Parte.
                setUsuariosLista(usuarios.sort((a, b) => (a.label > b.label) ? 1 : -1));
            })
            .catch(() => {
                mostrarError("No se ha podido listar los Usuarios.");
                console.log("No se ha podido listar los Usuarios.");
            })
    };

    const listarUsuariosHotel = (id_hotel) => {
        //Contendrá el listado de usuarios temporalmente.
        let usuarios = [];
        //Añadimos el primer valor vacio para el select.
        usuarios.push({ value: '', label: '' });

        fd.append("f", "usuarios.getUsuariosHotel");
        fd.append("token", localStorage.getItem('token'));
        fd.append("id_hotel", id_hotel);

        fetch('https://api.workers.grupotel.com/', requestOptions)
            .then(response => response.json())
            .then(result => {
                //Recorremos el array de Usuarios para obtener sus id de Usuario y nombres.
                if (result.usuarios) {
                    usuarios = usuarios.concat(
                        Object.keys(result.usuarios).map(id => ({
                            value: id,
                            label: result.usuarios[id]
                        }))
                    );
                    setUsuariosHotel(usuarios.sort((a, b) => a.label.localeCompare(b.label)));
                    let rol = localStorage.getItem('id_rol');
                    if (rol == 12) { //Si es director en asignados mostramos todos los usuarios
                        setUsuariosLista(usuarios.sort((a, b) => a.label.localeCompare(b.label)));
                    }
                } else {
                    setUsuariosHotel([]);
                }
            })
            .catch(() => {
                mostrarError("No se ha podido listar los Usuarios.");
                console.log("No se ha podido listar los Usuarios.");
            })
    };

    const obtenerBloquesHotel = (id_hotel) => {
        let bloques = [];
        //Añadimos el primer valor vacio para el select.
        // bloques.push({ value: '', label: '' });

        fd.append("f", "hotel.getBloquesHotel");
        fd.append("token", localStorage.getItem('token'));
        fd.append("id_hotel", id_hotel);

        fetch('https://api.workers.grupotel.com/', requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.error.id === 0) {
                    let bloquesTransformados = result.bloques.map(bloque => ({
                        value: bloque.id,
                        label: bloque.bloque
                    }));
                    // Concadenamos los valores por defecto con el array de bloques
                    bloques = bloques.concat(bloquesTransformados).sort((a, b) => (a.label > b.label) ? 1 : -1);

                    setBloquesLista(bloques);
                } else {
                    setBloquesLista([]);
                    setDatosFiltroPartes({
                        ...datosFiltroPartes,
                        'bloque': []
                    });
                    // mostrarError(result.error.msg);
                }
            })
            .catch(() => {
                mostrarError("No se ha podido obtener los Bloques del Hotel");
                console.log("No se ha podido obtener los Bloques del Hotel");
            })
    };

    // Función para obtener las plantas de Uno o Varios Bloques
    const obtenerPlantasHotel = (id_bloque) => {
        fd.append("f", "hotel.getPlantasHotel");
        fd.append("token", localStorage.getItem('token'));
        fd.append("id_hotel", hotelTrabajo);
        fd.append("id_bloque", id_bloque);

        fetch('https://api.workers.grupotel.com/', requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.error.id === 0) {
                    // console.log(result.plantas)
                    setPlantasLista(result.plantas);
                } else {
                    setPlantasLista([]);
                    setDatosFiltroPartes({
                        ...datosFiltroPartes,
                        'planta': [], // Nos aseguramos de que 'value' sea siempre un array
                    });
                    mostrarError(result.error.msg);
                    console.log(result.error.msg);
                }
            })
            .catch(() => {
                mostrarError("No se ha podido obtener las Plantas del Hotel");
                console.log("No se ha podido obtener las Plantas del Hotel");
            })
    };

    const actualizarFiltrosPartes = (event) => {
        const { name, value } = event.target;

        if (name === 'bloque') {
            // Si la opción vacía se selecciona junto con otras opciones
            var temp = typeof value === 'string' ? value.split(',') : value;
            // Si no hay opción vacía seleccionada, procesamos normalmente
            setDatosFiltroPartes({
                ...datosFiltroPartes,
                [name]: temp // Aseguramos que 'value' sea siempre un array
            });
            if (temp.length > 0) {
                obtenerPlantasHotel(temp);
            } else {
                setPlantasLista([]);
            }
        } else if (name === 'id') {
            const validValue = value.replace(/[^0-9,]/g, ''); // Eliminar cualquier carácter no numérico o coma
            setDatosFiltroPartes({
                ...datosFiltroPartes,
                [name]: validValue,
            });
        } else {
            setDatosFiltroPartes({
                ...datosFiltroPartes,
                [name]: value,
            });
        }
    };

    const actualizarFechaDesdePartes = (fecha) => {
        setDatosFiltroPartes({ ...datosFiltroPartes, fecha_desde: fecha });
    };
    const actualizarFechaHastaPartes = (fecha) => {
        setDatosFiltroPartes({ ...datosFiltroPartes, fecha_hasta: fecha });
    };

    const mostrarFiltroPartes = () => {
        obtenerDatosSelect();
        if (hotelTrabajo != 0) {
            obtenerUsuarios();
            listarUsuariosHotel(hotelTrabajo);
            obtenerBloquesHotel(hotelTrabajo);
        } else {
            setUsuariosLista([{ value: '', label: '' }]);
            setUsuariosHotel([{ value: '', label: '' }]);
            setBloquesLista([]);
            setPlantasLista([]);
        }
        setDatosFiltroPartesTemp({ ...datosFiltroPartes });
        setActivoFiltroPartes(true);
        setEstadoFiltroPartes(true);
    };

    const eliminarFiltroPartes = () => {
        setDatosFiltroPartes({
            id: '',
            titulo: '',
            operacion: '',
            tipo: '',
            prioridad: '',
            bloque: [],
            planta: [],
            hab: '',
            fecha_desde: '',
            fecha_hasta: '',
            id_asignado: '',
            id_creador: '',
            historico_observacion: ''
        });
        setPlantasLista([]);
        setBloquesLista([]);
        setUsuariosHotel([]);
    };
    const ocultarFiltroPartes = () => {
        setEstadoFiltroPartes(false);
        actualizar2();
    };

    const ocultarFiltroPartes2 = () => { // Solo oculta los filtros.
        setEstadoFiltroPartes(false);
        setDatosFiltroPartes(datosFiltroPartesTemp);
        comprobarEstadoFiltroPartes();
    };

    const comprobarESCPartes = (event) => {
        if (event.keyCode === 27) {
            ocultarFiltroPartes();
        }
    };
    const comprobarEstadoFiltroPartes = () => { // Comprobamos si hay algun valor en datosFiltro
        const hayFiltrosActivos = Object.values(datosFiltroPartes).some(
            (valor) => valor !== '' && valor !== false && valor !== 0 && valor.length !== 0
        );
        setActivoFiltroPartes(hayFiltrosActivos);
    };

    const guardarDatosPartes = () => {
        // console.log("Información Filtros")
        // console.log(datos);
        // console.log(str)
        setEstadoFiltroPartes(false);
        comprobarEstadoFiltroPartes();
        actualizar2();
    };

    /***********************************************/
    const getFacturas = () => {
        // console.log("Hotel trabajo " + hotelTrabajo);
        // console.log(hotelesLista);

        fd.append("f", "partes.getFacturasConf");
        fd.append("token", localStorage.getItem('token'));
        fd.append("id_hotel", hotelTrabajo);

        const datos = datosFiltro;
        var params = '';
        Object.keys(datos).forEach((nombre, i) => {
            if (Object.values(datos)[i] !== '' && Object.values(datos)[i] !== undefined) {
                if (nombre === "fecha_hasta" || nombre === "fecha_desde") {
                    let fecha_ordenada = "";

                    // Dividir la cadena de la fecha en partes usando el separador "-"
                    const partes = Object.values(datos)[i].split("-");

                    // Reorganizar las partes para que la fecha esté en formato "yyyy-mm-dd"
                    fecha_ordenada = partes[2] + "-" + partes[1] + "-" + partes[0];
                    params += nombre + "=" + fecha_ordenada + '|';
                } else {
                    params += nombre + "=" + Object.values(datos)[i] + '|';
                }
            }
        });
        var id = localStorage.getItem('id');
        params += "id_usuario=" + id + '|';

        fd.append("params", params);
        fetch('https://api.workers.grupotel.com/', requestOptions)
            .then(response => response.json(), setContadorSpinner(true))
            .then(result => {
                // console.log(params);
                // console.log(result);
                let error = result.error;
                if (error.id === 0) {
                    let infoFactura = result.facturas;
                    // console.log(infoFactura)

                    const timer2 = setTimeout(() => {
                        setContadorSpinner(false);
                        setDatos(infoFactura);
                        mostrarError("Actualizado", "success");
                    }, 1000);

                    return () => clearTimeout(timer2);

                } else if (error.id >= 501 && error.id <= 510) {
                    localStorage.setItem('token', 'CADUCADO');
                    window.location.reload();
                } else if (error.id === 102) {
                    const timer2 = setTimeout(() => {
                        setContadorSpinner(false);
                        setDatos([]);
                        mostrarError(error.msg);
                        console.log(error.msg);
                    }, 1000);
                    return () => clearTimeout(timer2);
                } else {
                    const timer2 = setTimeout(() => {
                        setContadorSpinner(false);
                        setDatos([]);
                        mostrarError(error.msg);
                        console.log(error.msg);
                    }, 1000);
                    return () => clearTimeout(timer2);
                }
            })
    };

    const getPartes = (params, partes) => {
        // console.log(params)
        // console.log(partes)

        const { fecha } = facturaSeleccionada.length ? facturaSeleccionada[0] : '';
        if (fecha && partes == "") {
            mostrarError("La factura no tiene partes asociados.", "success");
            setListaPartes('');
        } else {
            fd.append("f", "partes.getList2");
            fd.append("token", localStorage.getItem('token'));
            fd.append("params", params);
            if (fecha) {
                fd.append("soloPartes", true);
                // console.log("Solo Partes")
            }

            setContadorSpinner(true);

            fetch(API_URL, requestOptions)
                .then(response => response.json())
                .then(result => {
                    let error = result.error;
                    // console.log(result);
                    if (error.id === 0) {
                        let partes = Object.values(result.partes).map(parte => {
                            return Object.keys(parte).reduce((parteObj, key, j) => {
                                parteObj[key] = Object.values(parte)[j];
                                return parteObj;
                            }, {});
                        });
                        // console.log(partes);
                        setTimeout(() => {
                            setContadorSpinner(false);
                            setListaPartes(partes);
                            mostrarError("Actualizado", "success");
                        }, 1000);

                    } else if (error.id >= 501 && error.id <= 510) {
                        localStorage.setItem('token', 'CADUCADO');
                        window.location.reload();
                    } else {
                        setTimeout(() => {
                            setContadorSpinner(false);
                            setListaPartes('');
                            mostrarError(error.msg);
                            console.log(error.msg);
                        }, 1000);
                    }
                });
        }
    };

    const comprobarPartes = () => {
        let params = hotelTrabajo ? `id_hotel=${hotelTrabajo}|` : "";
        let partes = "";
        if (!facturaSeleccionada.length) {
            if (activoFiltroPartes) {
                Object.entries(datosFiltroPartes).forEach(([nombre, valor]) => {
                    if (!valor || (Array.isArray(valor) && !valor.length)) return;

                    if (["fecha_hasta", "fecha_desde"].includes(nombre)) {
                        const [dd, mm, yyyy] = valor.split("-");
                        params += `${nombre}=${yyyy}-${mm}-${dd}|`;
                    } else if (nombre === "operacion" && valor === "abierto") {
                        params += "abierto=1|";
                    } else if (Array.isArray(valor)) {
                        params += `${nombre}=${valor.join(",")}|`; // Unimos arrays en una cadena separada por comas
                    } else {
                        params += `${nombre}=${valor}|`;
                    }
                });
            } else {
                // console.log("No hay factura seleccionada.");
                return;
            }
        } else {
            const { id_factura, cif, partes, fecha } = facturaSeleccionada[0];

            setIdPartes(partes || "");
            setDisabledPartes(!!fecha);

            if (partes) {
                params += `id=${partes}|`;
                setBotonFiltroPartes(true);
            } else {
                if (fecha) {
                    setBotonFiltroPartes(true);
                } else {
                    if (activoFiltroPartes) {
                        Object.entries(datosFiltroPartes).forEach(([nombre, valor]) => {
                            if (!valor || (Array.isArray(valor) && !valor.length)) return;

                            if (["fecha_hasta", "fecha_desde"].includes(nombre)) {
                                const [dd, mm, yyyy] = valor.split("-");
                                params += `${nombre}=${yyyy}-${mm}-${dd}|`;
                            } else if (nombre === "operacion" && valor === "abierto") {
                                params += "abierto=1|";
                            } else if (Array.isArray(valor)) {
                                params += `${nombre}=${valor.join(",")}|`; // Unimos arrays en una cadena separada por comas
                            } else {
                                params += `${nombre}=${valor}|`;
                            }
                        });
                    } else {
                        params += `cif_proveedor=${cif}|`;
                    }
                    setBotonFiltroPartes(false);
                }
            }
        }
        // console.log("Datos params:", params);
        getPartes(params, partes);
    };

    const comprobarEnter2 = (e) => {
        if (e.key === 'Enter') {
            actualizar2();
        }
    };

    const [editandoIdFactura, setEditandoIdFactura] = useState(null); // ID de la factura en edición
    const [editIdPartes, setEditIdPartes] = useState(""); // Partes seleccionados en la tabla de Partes.

    const handleEditarPartes = (row) => {
        setEditIdPartes(row.partes || "");
        setEditandoIdFactura(row.id_factura);
    };

    const handleSeleccionarParte = (idParte) => {
        setEditIdPartes((prev) => {
            const partesArray = prev ? prev.split(",").filter(Boolean) : [];
            const parteIndex = partesArray.indexOf(idParte.toString());
            if (parteIndex > -1) {
                // Si ya está seleccionado, lo deselecciona
                partesArray.splice(parteIndex, 1);
            } else {
                // Si no está seleccionado, lo añade
                partesArray.push(idParte.toString());
            }
            return partesArray.join(",");
        });
    };

    /***************************/
    // Dialog para pre conformar
    const [estadoConfirmar, setEstadoConfirmar] = React.useState(false);
    const [confirmando, setConfirmando] = React.useState(false);
    const [mensajeConformar, setMensajeConformar] = useState("");
    const [observacion, setObservacion] = useState("");

    const mostrarConfirmarGuardar = () => {
        if (editIdPartes) {
            setMensajeConformar("Conformar la factura con los partes: " + editIdPartes);
        }
        setEstadoConfirmar(true);
    };

    const comprobarESCConfirmar = (event) => {
        if (event.keyCode === 27) {
            cancelConfirmar();
        }
    };
    const cancelConfirmar = () => {
        setObservacion("");
        setMensajeConformar('');
        setConfirmando(false);
        setEstadoConfirmar(false);
    };

    const confirmarFactura = () => {
        setConfirmando(true);

        const fd = new FormData();
        fd.append("f", "partes.setConfirmarFactura");
        fd.append("token", localStorage.getItem('token'));
        fd.append("id_factura", editandoIdFactura);
        if (editIdPartes) {
            fd.append("id_partes", editIdPartes);
        }
        if (observacion.trim()) {
            fd.append("observaciones", observacion.trim());
        }
        
        const requestOptions = {
            method: 'POST',
            body: fd
        };
        fetch(API_URL, requestOptions)
            .then(response => response.json())
            .then(result => {
                // console.log(result)
                let error = result.error;
                if (error.id === 0) {
                    mostrarError("Factura Confirmada", "success");
                    setObservacion("");
                    setEditandoIdFactura(null);
                    setEditIdPartes("");
                } else {
                    mostrarError(error.msg);
                }
                setConfirmando(false);
            })
            .catch(() => {
                mostrarError("No se ha podido Confirmar la Factura " + editandoIdFactura);
            })

        cancelConfirmar();
        actualizar();
    };

    /***************************/
    const PartesCell = ({ row }) => {
        return (
            <Box display="flex" alignItems="center" gap={1}>
                {editandoIdFactura === row.id_factura && row.fecha == null ? (// Verifica si esta fila está en modo edición
                    <TextField
                        size="small"
                        variant="outlined"
                        placeholder="Agregar partes"
                        value={editIdPartes}
                        onChange={(e) => {
                            // console.log(e);
                            setEditIdPartes(e.target.value);
                        }}
                        onClick={(event) => event.stopPropagation()} // Evita que se active onRowClick
                    />
                ) : (
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={(event) => {
                            event.stopPropagation();
                            handleEditarPartes(row); // Cambia a modo de edición
                        }}
                    >
                        Editar
                    </Button>
                )}
            </Box>
        );
    };

    const seleccionarFactura = (params) => {
        setFacturaSeleccionada([params.row]);
        if (editandoIdFactura !== null && editandoIdFactura !== params.row.id_factura) {
            setEditandoIdFactura(null);
            setEditIdPartes("");
        }
    };

    const columnasFacturas = [
        {
            headerClassName: 'header-grid',
            field: 'id_factura',
            headerName: 'ID Factura',
            width: 70,
            renderCell: (params) => (
                <div
                    onClick={() => seleccionarFactura({ row: params.row })}
                    style={{ width: '100%', height: '100%', 'align-content': 'center' }}
                >
                    {params.value}
                </div>
            )
        },
        {
            headerClassName: 'header-grid',
            field: 'cif',
            headerName: 'CIF',
            width: 78,
            renderCell: (params) => (
                <div
                    onClick={() => seleccionarFactura({ row: params.row })}
                    style={{ width: '100%', height: '100%', 'align-content': 'center' }}
                >
                    {params.value}
                </div>
            )
        },
        {
            headerClassName: 'header-grid',
            field: 'url',
            headerName: 'Ver Factura',
            width: 76,
            renderCell: (params) => (
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={() => {
                        window.open("https://grupotel2.signes30.com/signes/visor/web/verdocumento.ashx?guid=" + params.row.url, '_blank');
                        // console.log(params.row);
                        // console.log(params.row.url)
                    }}
                >
                    Ver
                </Button>
            ),

        },
        {
            headerClassName: 'header-grid',
            field: 'partes',
            headerName: 'Partes',
            width: 190,
            renderCell: (params) => (
                params.row.fecha != null ?
                    <div
                        onClick={() => seleccionarFactura({ row: params.row })}
                        style={{ width: '100%', height: '100%', 'align-content': 'center' }}
                    >
                        {params.row.partes}
                    </div> :
                    <PartesCell row={params.row} />
            ),
        },
        {
            headerClassName: 'header-grid',
            field: 'observaciones',
            headerName: 'OBS',
            width: 196,
            // height: 100,
            renderCell: (params) => {
                // Función para limitar la cantidad de caracteres
                const limitar = (text, maxLength) =>
                    text?.length > maxLength ? text.substring(0, maxLength) + '…' : text;
                return (
                    params.value ?
                        <HtmlTooltip
                            placement="top-start" enterDelay={500} leaveDelay={200} TransitionComponent={Zoom} followCursor
                            title={
                                <React.Fragment>
                                    <Typography color="inherit">{params.value}</Typography>
                                </React.Fragment>
                            }
                        >
                            <div
                                onClick={() => seleccionarFactura({ row: params.row })}
                                style={{
                                    width: '100%', height: '100%', 'align-content': 'center',
                                    'white-space': 'break-spaces',
                                    // 'overflow': 'auto'
                                }}
                            >
                                {limitar(params.value, 30)}
                                {/* {params.value} */}
                            </div>
                        </HtmlTooltip>
                        : <div
                            onClick={() => seleccionarFactura({ row: params.row })}
                            style={{ width: '100%', height: '100%', 'align-content': 'center' }}
                        >
                        </div>
                );
            }
        },
        {
            headerClassName: 'header-grid',
            field: 'fecha',
            headerName: 'Fecha',
            width: 122,
            renderCell: (params) => (
                <div
                    onClick={() => seleccionarFactura({ row: params.row })}
                    style={{ width: '100%', height: '100%', 'align-content': 'center' }}
                >
                    {params.value}
                </div>
            )
        },
        {
            headerClassName: 'header-grid',
            field: 'conformar',
            headerName: 'Conformar',
            width: 76,
            renderCell: (params) =>
                !params.row.fecha && (
                    <HtmlTooltip
                        placement="left"
                        enterDelay={300}
                        leaveDelay={200}
                        TransitionComponent={Zoom}
                        title={
                            <React.Fragment>
                                <Typography color="inherit">{"Conformar"}</Typography>
                            </React.Fragment>
                        }
                    >
                        <Button
                            className="nuevoParte"
                            onClick={() => {
                                setEditandoIdFactura(params.row.id_factura);
                                mostrarConfirmarGuardar();
                            }}
                        >
                            <CheckCircleIcon className="icon-button" />
                        </Button>
                    </HtmlTooltip>
                ),
        }
    ];

    const columnasPartes = [
        {
            headerClassName: 'header-grid',
            field: 'seleccionar',
            headerName: 'Seleccionar',
            width: 120,
            renderCell: (params) => (
                <Checkbox
                    checked={editIdPartes.split(",").includes(params.row.id_parte.toString())}
                    onChange={() => handleSeleccionarParte(params.row.id_parte)}
                    disabled={editandoIdFactura === null}
                />
            ),
        },
        {
            headerClassName: 'header-grid',
            field: 'id_parte',
            headerName: 'ID Parte',
            width: 110,
        },
        {
            headerClassName: 'header-grid',
            field: 'titulo_corto',
            headerName: 'Titulo',
            width: 300,
        }
    ];

    useEffect(() => {
        let listaHoteles = JSON.parse(hoteles);
        listaHoteles.unshift({ "value": "0", "label": "..." });
        setHotelesLista(listaHoteles);

        //Si tenemos un hotel guardado en el localStorage utilizando Ajustes.
        let idHotel = localStorage.getItem('idHotelSeleccionado');
        if (estadoInicial) {
            if (idHotel) {
                setHotelTrabajo(idHotel);
                setEstadoInicial(false);
            }
            // else {
            //     console.log(listaHoteles);
            // }
        }
        getFacturas();
    }, [hotelTrabajo, actualizo]);

    useEffect(() => {
        setTablaFacturas(
            <DataGrid
                className='grid'
                rowHeight={50}
                // rowHeight={60}
                getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0 ? 'blanco' : 'fondogris blanco'
                }
                getRowId={(row) => row.id_factura}
                rows={datos}
                columns={columnasFacturas}
                maxColumns={7}
                pageSize={14}
                rowsPerPageOptions={[14]}
                localeText={{
                    noRowsLabel: "No se han encontrado datos.",
                    noResultsOverlayLabel: "No se ha encontrado ningún resultado",
                }}
            />
        );
    }, [datos, editandoIdFactura, editIdPartes]);

    useEffect(() => {
        setTablaPartes(
            <DataGrid
                className='grid'
                rowHeight={48}
                getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0 ? 'blanco' : 'fondogris blanco'
                }
                getRowId={(row) => row.id_parte}
                rows={listaPartes} // Aquí van los datos de partes
                columns={columnasPartes}
                maxColumns={8}
                pageSize={12}
                rowsPerPageOptions={[12]}
                localeText={{
                    noRowsLabel: "No se han encontrado datos.",
                    noResultsOverlayLabel: "No se ha encontrado ningún resultado",
                }}
            />
        );
    }, [listaPartes, columnasPartes]);

    useEffect(() => {
        // Actualizamos la petición de partes. // Del CIF, seleccionado.
        comprobarPartes();
    }, [actualizo2, facturaSeleccionada]);

    return (
        <>
            <div className='container'>
                <div className='content'>
                    <div className='article'>
                        <div>
                            <div className='header'>
                                <div className='containerAcciones'>
                                    <ButtonGroup className="botonera" variant="contained" aria-label="outlined button group">
                                        <HtmlTooltip
                                            placement="bottom" enterDelay={500} leaveDelay={200} TransitionComponent={Zoom}
                                            title={
                                                <React.Fragment>
                                                    <Typography color="inherit">{"Filtrar"}</Typography>
                                                </React.Fragment>
                                            }
                                        >
                                            <Button
                                                className={activoFiltro === true ? "boton filtro pintado" : "boton filtro"}
                                                onClick={mostrarFiltros}
                                            >
                                                <FilterAltIcon className='icon-button' />
                                            </Button>
                                        </HtmlTooltip>

                                        <HtmlTooltip
                                            placement="bottom" enterDelay={500} leaveDelay={200} TransitionComponent={Zoom}
                                            title={
                                                <React.Fragment>
                                                    <Typography color="inherit">{"Actualizar"}</Typography>
                                                </React.Fragment>
                                            }
                                        >
                                            <Button
                                                className="boton"
                                                onClick={actualizar}
                                            >
                                                <RotateLeftIcon className='icon-button' />
                                            </Button>
                                        </HtmlTooltip>
                                    </ButtonGroup>
                                    <TextField
                                        className='fifty'
                                        variant="outlined"
                                        margin="normal"
                                        label="Hotel"
                                        name="id_hotel"
                                        size="small"
                                        value={hotelTrabajo ? hotelTrabajo : ""}
                                        onChange={cambiaHotelTrabajo}
                                        select
                                        SelectProps={{
                                            MenuProps: {
                                                PaperProps: {
                                                    sx: { maxHeight: { sm: 36 * 8 + 8 } }
                                                }
                                            }
                                        }}
                                    >
                                        {hotelesLista.map((hotel) => (
                                            <MenuItem key={hotel.value} value={hotel.value} >
                                                {hotel.label}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </div>
                                <div className='grid-container'>
                                    {tablaFacturas}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='aside' >
                        <div className='header'>
                            <div className='containerAcciones'>
                                <ButtonGroup className="botonera" variant="contained" aria-label="outlined button group">
                                    <HtmlTooltip
                                        placement="bottom" enterDelay={500} leaveDelay={200} TransitionComponent={Zoom}
                                        title={
                                            <React.Fragment>
                                                <Typography color="inherit">{"Filtrar Partes"}</Typography>
                                            </React.Fragment>
                                        }
                                    >
                                        <span>
                                            <Button
                                                id="filtroPartes"
                                                className={activoFiltroPartes === true ? "boton filtro pintado" : "boton filtro"}
                                                disabled={botonFiltroPartes}
                                                onClick={mostrarFiltroPartes}
                                            >
                                                <FilterAltIcon className='icon-button' />
                                            </Button>
                                        </span>
                                    </HtmlTooltip>
                                    <HtmlTooltip
                                        placement="bottom" enterDelay={500} leaveDelay={200} TransitionComponent={Zoom}
                                        title={
                                            <React.Fragment>
                                                <Typography color="inherit">{"Actualizar Partes"}</Typography>
                                            </React.Fragment>
                                        }
                                    >
                                        <Button
                                            className="boton"
                                            onClick={actualizar2}
                                        >
                                            <RotateLeftIcon className='icon-button' />
                                        </Button>
                                    </HtmlTooltip>
                                </ButtonGroup>
                                <TextField
                                    className='fifty'
                                    variant="outlined"
                                    margin="normal"
                                    type="text"
                                    label="ID Partes"
                                    onKeyPress={(ev) => { comprobarEnter2(ev) }}
                                    name="id_parte"
                                    id="id_parte"
                                    size="small"
                                    value={idPartes || ''}
                                    onChange={actualizarPartes}
                                    autoComplete="off"
                                    disabled={true}
                                />
                            </div>
                        </div>
                        <div className='grid-container'>
                            {tablaPartes}
                        </div>
                    </div>
                </div>
            </div>

            <Dialog fullScreen={fullScreen}
                open={estadoFiltros}
                onClose={comprobarESC}
                aria-labelledby="responsive-dialog-title" id="dialogoFiltros">
                <DialogTitle>Filtros</DialogTitle>
                <DialogContent >
                    <form>
                        <div className='bloque-inputs-filtros '>
                            <TextField
                                variant="outlined"
                                margin="normal"
                                type="text"
                                label="ID Factura"
                                onKeyPress={(ev) => { comprobarEnter(ev) }}
                                name="id_factura"
                                size="small"
                                value={datosFiltro.id_factura ? datosFiltro.id_factura : ''}
                                onChange={actualizarFiltros}
                                autoComplete="off"
                            />
                            <TextField
                                variant="outlined"
                                margin="normal"
                                type="text"
                                label="Nº Factura"
                                onKeyPress={(ev) => { comprobarEnter(ev) }}
                                name="n_factura"
                                size="small"
                                value={datosFiltro.n_factura ? datosFiltro.n_factura : ''}
                                onChange={actualizarFiltros}
                                autoComplete="off"
                            />
                            <TextField
                                variant="outlined"
                                margin="normal"
                                type="text"
                                label="CIF"
                                onKeyPress={(ev) => { comprobarEnter(ev) }}
                                name="cif"
                                size="small"
                                value={datosFiltro.cif ? datosFiltro.cif : ''}
                                onChange={actualizarFiltros}
                                autoComplete="off"
                            />
                            <TextField
                                variant="outlined"
                                margin="normal"
                                label="Facturas"
                                name="mostrar"
                                size="small"
                                value={datosFiltro.mostrar ? datosFiltro.mostrar : ''}
                                onChange={actualizarFiltros}
                                select
                            >
                                {tipoMostrar.map((mostrar) => (
                                    <MenuItem key={`filtros-${mostrar.value}`} value={mostrar.value}>
                                        {mostrar.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                            <TextFieldFecha
                                idFormulario={1}
                                nombreTextField="fecha_desde"
                                textoLabel="Desde"
                                claseFormControl='grupotel-cuarto'
                                claseTextField='input'
                                actualizarFecha={actualizarFechaDesde}
                                valorInicial={datosFiltro.fecha_desde ? datosFiltro.fecha_desde : ''}
                            />
                            <TextFieldFecha
                                idFormulario={2}
                                nombreTextField="fecha_hasta"
                                textoLabel="Hasta"
                                claseFormControl='grupotel-cuarto'
                                claseTextField='input'
                                actualizarFecha={actualizarFechaHasta}
                                valorInicial={datosFiltro.fecha_hasta ? datosFiltro.fecha_hasta : ''}
                            />
                        </div>
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button className="colorGrupo botonBorrarFiltros" onClick={eliminarFiltros}>Limpiar Filtros</Button>
                    <ButtonGroup className="botonera" variant="contained" aria-label="outlined button group">
                        <Button className="colorGrupo" onClick={ocultarFiltros2}>Cancelar</Button>
                        <Button className="colorGrupo" onClick={guardarDatos}>Filtrar</Button>
                    </ButtonGroup>
                </DialogActions>
            </Dialog>
            <Dialog fullScreen={fullScreen}
                open={estadoFiltroPartes}
                onClose={comprobarESCPartes}
                aria-labelledby="responsive-dialog-title" id="dialogoFiltroPartes">
                <DialogTitle>Filtros Partes</DialogTitle>
                <DialogContent>
                    <form>
                        <div className='bloque-inputs-filtros '>
                            <TextField
                                className='inputMitad'
                                variant="outlined"
                                margin="normal"
                                type="text"
                                label="ID"
                                placeholder="12345,123456,23145"
                                onKeyPress={(ev) => { comprobarEnter(ev) }}
                                name="id"
                                size="small"
                                value={datosFiltroPartes.id ? datosFiltroPartes.id : ''}
                                onChange={actualizarFiltrosPartes}
                                autoComplete="off"
                            />

                            <TextField
                                variant="outlined"
                                margin="normal"
                                label="Estado"
                                name="operacion"
                                size="small"
                                value={datosFiltroPartes.operacion ? datosFiltroPartes.operacion : ''}
                                onChange={actualizarFiltrosPartes}
                                select
                            >
                                {tipoEstados.map((tipoEstado) => (
                                    <MenuItem key={`filtrosEstado-${tipoEstado.valor}`} value={tipoEstado.valor}>
                                        {tipoEstado.nombre}
                                    </MenuItem>
                                ))}
                            </TextField>

                            <TextField
                                variant="outlined"
                                margin="normal"
                                label="Tipo parte"
                                name="tipo"
                                size="small"
                                value={datosFiltroPartes.tipo ? datosFiltroPartes.tipo : ''}
                                onChange={actualizarFiltrosPartes}
                                select
                            >
                                {tipoPartes
                                    .sort((a, b) => a.orden - b.orden) // Ordenar por el campo 'orden' de forma ascendente
                                    .map((tipoParte) => (
                                        <MenuItem key={`filtrosTipo-${tipoParte.valor}`} value={tipoParte.valor}>
                                            <Tooltip
                                                title={tipoParte.descripcion && tipoParte.descripcion.trim() ? tipoParte.descripcion : ''} // Mostrar solo si hay descripción
                                                placement="right"
                                            >
                                                <span>{tipoParte.nombre}</span> {/* Envolver el texto del menú, no el componente entero */}
                                            </Tooltip>
                                        </MenuItem>
                                    ))}
                            </TextField>

                            <TextField
                                variant="outlined"
                                margin="normal"
                                label="Prioridad parte"
                                name="prioridad"
                                size="small"
                                value={datosFiltroPartes.prioridad ? datosFiltroPartes.prioridad : ''}
                                onChange={actualizarFiltrosPartes}
                                select
                            >
                                {tipoPrioridad.map((prioridad) => (
                                    <MenuItem key={`filtrosTipo-${prioridad.valor}`} value={prioridad.valor}>
                                        {prioridad.nombre}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </div>
                        <div className='divFiltros'>
                            <div className='divFiltrosContainer'>
                                <h4>Filtros de Usuarios</h4>
                                <div className='divFiltrosTextField'>
                                    <TextField
                                        variant="outlined"
                                        margin="normal"
                                        label="Usuario Asignado"
                                        name="id_asignado"
                                        size="small"
                                        value={datosFiltroPartes.id_asignado ? datosFiltroPartes.id_asignado : ''}
                                        onChange={actualizarFiltrosPartes}
                                        select
                                    >
                                        {usuariosLista.map((usuario) => (
                                            <MenuItem key={`filtrosAsignado-${usuario.value}`} value={usuario.value}>
                                                {usuario.label}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    <TextField
                                        variant="outlined"
                                        margin="normal"
                                        label="Creador del parte"
                                        name="id_creador"
                                        size="small"
                                        value={datosFiltroPartes.id_creador ? datosFiltroPartes.id_creador : ''}
                                        onChange={actualizarFiltrosPartes}
                                        select
                                    >
                                        {usuariosHotel.map((usuario) => (
                                            <MenuItem key={`filtrosCreador-${usuario.value}`} value={usuario.value}>
                                                {usuario.label}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </div>
                            </div>
                            <div className='divFiltrosContainer'>
                                <h4>Fecha de Creación</h4>
                                <div className='divFiltrosTextField'>
                                    <TextFieldFecha
                                        idFormulario={4}
                                        nombreTextField="fecha_desde"
                                        textoLabel="Desde"
                                        claseFormControl='grupotel-cuarto'
                                        claseTextField='input'
                                        actualizarFecha={actualizarFechaDesdePartes}
                                        valorInicial={datosFiltroPartes.fecha_desde ? datosFiltroPartes.fecha_desde : ''}
                                    />

                                    <TextFieldFecha
                                        idFormulario={5}
                                        nombreTextField="fecha_hasta"
                                        textoLabel="Hasta"
                                        claseFormControl='grupotel-cuarto'
                                        claseTextField='input'
                                        actualizarFecha={actualizarFechaHastaPartes}
                                        valorInicial={datosFiltroPartes.fecha_hasta ? datosFiltroPartes.fecha_hasta : ''}
                                    />
                                </div>
                            </div>

                        </div>
                        <div className='divFiltros'>
                            <div className='divFiltrosContainer'>
                                <h4>Filtros de Habitación</h4>
                                <div className='divFiltrosTextField'>
                                    <TextField
                                        variant="outlined"
                                        margin="normal"
                                        label="Bloque"
                                        name="bloque"
                                        size="small"
                                        value={datosFiltroPartes.bloque}
                                        onChange={actualizarFiltrosPartes}
                                        select
                                        SelectProps={{
                                            multiple: true,
                                        }}
                                    >
                                        {bloquesLista.map((bloque) => (
                                            <MenuItem key={`filtrosBloque-${bloque.value}`} value={bloque.value}>
                                                {bloque.label}
                                            </MenuItem>
                                        ))}
                                    </TextField>

                                    <TextField
                                        variant="outlined"
                                        margin="normal"
                                        label="Planta"
                                        name="planta"
                                        size="small"
                                        value={datosFiltroPartes.planta}
                                        onChange={actualizarFiltrosPartes}
                                        select
                                        SelectProps={{
                                            multiple: true,
                                        }}
                                    >
                                        {plantasLista.map((planta) => (
                                            <MenuItem key={`${planta.bloque} - P${planta.planta}`} value={`${planta.id_bloque}-${planta.planta}`} id={`${planta.bloque} - P${planta.planta}`}>
                                                {`${planta.bloque} - P${planta.planta}`}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    <TextField
                                        variant="outlined"
                                        margin="normal"
                                        id="filtroHabitacion"
                                        label="Habitación"
                                        onKeyPress={(ev) => { comprobarEnter(ev) }}
                                        name="hab"
                                        size="small"
                                        value={datosFiltroPartes.hab ? datosFiltroPartes.hab : ''}
                                        onChange={actualizarFiltrosPartes}
                                        autoComplete="off"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='divFiltros'>
                            <div className='divFiltrosContainer'>
                                <h4>Observaciones</h4>
                                <div className='divFiltrosTextField'>

                                    <TextField
                                        className='observaciones '
                                        label="Observaciones"
                                        name="historico_observacion"
                                        size="small"
                                        multiline
                                        rows={2}
                                        value={datosFiltroPartes.historico_observacion ? datosFiltroPartes.historico_observacion : ''}
                                        onChange={actualizarFiltrosPartes}
                                    />
                                </div>
                            </div>
                            <div className='divFiltrosContainer'>
                                <h4>Filtro Titulo</h4>
                                <div className='divFiltrosTitulo'>
                                    <TextField
                                        variant="outlined"
                                        margin="normal"
                                        label="Titulo"
                                        onKeyPress={(ev) => { comprobarEnter(ev) }}
                                        name="titulo"
                                        size="small"
                                        InputLabelProps={{ className: 'bold' }}
                                        value={datosFiltroPartes.titulo ? datosFiltroPartes.titulo : ''}
                                        onChange={actualizarFiltrosPartes}
                                        autoComplete="off"
                                    />
                                </div>
                            </div>
                        </div>
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button className="colorGrupo botonBorrarFiltros" onClick={eliminarFiltroPartes}>Limpiar Filtros</Button>
                    <ButtonGroup className="botonera" variant="contained" aria-label="outlined button group">
                        <Button className="colorGrupo" onClick={ocultarFiltroPartes2}>Cancelar</Button>
                        <Button className="colorGrupo" onClick={guardarDatosPartes}>Filtrar</Button>
                    </ButtonGroup>
                </DialogActions>
            </Dialog>
            <MostrarError mensajeEr={mensajeError} tipoError={tipoError} contadorError={contadorError} estadoAlert={estadoAlert} />
            <CargaSpinner contadorSpinner={contadorSpinner} />

            <Dialog fullScreen={fullScreen}
                open={estadoConfirmar}
                onClose={comprobarESCConfirmar}
                aria-labelledby="responsive-dialog-title" id="dialogBorrarGrupo">
                <DialogTitle>Seguro que quiere pre Conformar la factura? {editandoIdFactura}</DialogTitle>
                <DialogContent>
                    <div>
                        <div className=''>
                            <p>{mensajeConformar}</p>
                        </div>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            className='divObservaciones'
                            label="Observacion"
                            name="observaciones"
                            multiline
                            rows={7}
                            value={observacion ? observacion : ''}
                            onChange={(e) => setObservacion(e.target.value)}
                            autoComplete="off"
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <ButtonGroup className="botonera" variant="contained" aria-label="outlined button group">
                        <Button className="colorGrupo borrarBoton" onClick={cancelConfirmar}>Cancelar</Button>
                        {confirmando ?
                            <Button className="colorGrupo" >
                                <CircularProgress className="botonCarga" color="inherit" />
                            </Button>
                            : <Button className=" colorGrupo " onClick={confirmarFactura}>Confirmar</Button>
                        }
                    </ButtonGroup>
                </DialogActions>
            </Dialog>
        </>
    )
}
export default PreConforme;